import {GET_ALL_REFERENCES} from "../../../enums/Request/request.types";

export const getAllUserReferencesAction = (data) => {
    return {
        type: GET_ALL_REFERENCES,
        payload:data,
    };
};
